import React, { useEffect, useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const ModalGiftSelect = ({
  modalStatus,
  closeModal,
  gift
}) => {
  const afterOpenModal = () => {};

  const selfClose = (event) => {
    event.preventDefault();
    closeModal();
  };

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-gift-select"
    >
        <h2>
          <img src="/images/title-congrat2.png" alt="" className="title-modal"/>
        </h2>
        <div className="modal-description">
          <p>Bạn đã nhận được</p>
          <img src={gift?.image} alt="" />

          <p className="name">{gift?.desc}</p>
        </div>
    </Modal>
  )
}

export default ModalGiftSelect